/* eslint-disable jsx-a11y/accessible-emoji */
import React, { useState, useEffect, useRef } from "react";

const Logo = "https://cdzv.com/strategy_img/Image_2024-10-30_11-01-25.jpg";

const defaultProps = {
    "sm-padding": "8px 0 8px 0",
    "quarkly-title": "Header-3",
    "background": "transparent",
    "flex-direction": "column-reverse",
    "align-items": "stretch",
    "box-shadow": "none",
    "justify-content": "space-between",
    "padding": "0px 0 0 0",
    "position": "fixed",
    "flex-wrap": "no-wrap",
    "z-index": "250000",
    "overflow": "visible",
    "height": "80px",
    "margin": "0 0px 0 0px",
    "right": 0,
    "left": 0,
    "top": "0px",
    "bottom": "9211px"
};

const overrides = {};

const CdzvMenu_ua = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Scroll state handler for smooth sticky shrink effect
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 20) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    // Dropdown click outside listener
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Scroll locking when mobile drawer is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen]);

    return (
        <header className={`cdzv-custom-header ${isScrolled ? "scrolled" : ""}`}>
            <style dangerouslySetInnerHTML={{ __html: `
                .cdzv-custom-header {
                    position: fixed !important;
                    top: 0 !important;
                    left: 0 !important;
                    right: 0 !important;
                    height: 80px !important;
                    z-index: 250000 !important;
                    display: flex !important;
                    align-items: center !important;
                    box-sizing: border-box !important;
                    padding: 0 24px !important;
                    background: rgba(12, 6, 20, 0.6) !important;
                    backdrop-filter: blur(16px) !important;
                    -webkit-backdrop-filter: blur(16px) !important;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;
                    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.2) !important;
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
                }
                .cdzv-custom-header.scrolled {
                    background: rgba(8, 4, 15, 0.9) !important;
                    height: 68px !important;
                    border-bottom-color: rgba(255, 255, 255, 0.12) !important;
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5), 0 0 15px rgba(123, 47, 206, 0.1) !important;
                }

                .cdzv-header-container {
                    width: 100% !important;
                    max-width: 1200px !important;
                    margin: 0 auto !important;
                    display: flex !important;
                    align-items: center !important;
                    justify-content: space-between !important;
                }

                /* Nav links styling */
                .cdzv-nav-link {
                    color: rgba(255, 255, 255, 0.85) !important;
                    text-decoration: none !important;
                    font-size: 15px !important;
                    font-weight: 600 !important;
                    padding: 8px 16px !important;
                    position: relative !important;
                    transition: all 0.25s ease !important;
                }
                .cdzv-nav-link:hover {
                    color: #FD6DF9 !important;
                    text-shadow: 0 0 10px rgba(253, 109, 249, 0.4) !important;
                }
                .cdzv-nav-link::after {
                    content: '' !important;
                    position: absolute !important;
                    width: 60% !important;
                    height: 2px !important;
                    bottom: -2px !important;
                    left: 20% !important;
                    background: linear-gradient(90deg, #FD6DF9, #7b2fce) !important;
                    transform: scaleX(0) !important;
                    transform-origin: bottom right !important;
                    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
                }
                .cdzv-nav-link:hover::after {
                    transform: scaleX(1) !important;
                    transform-origin: bottom left !important;
                }

                /* Custom Dropdown for Doc Selector */
                .cdzv-dropdown-container {
                    position: relative !important;
                    display: inline-block !important;
                }
                .cdzv-dropdown-btn {
                    background: rgba(255, 255, 255, 0.05) !important;
                    color: #ffffff !important;
                    border: 1px solid rgba(255, 255, 255, 0.12) !important;
                    border-radius: 10px !important;
                    padding: 8px 16px !important;
                    font-size: 14px !important;
                    font-weight: 600 !important;
                    cursor: pointer !important;
                    display: flex !important;
                    align-items: center !important;
                    gap: 8px !important;
                    transition: all 0.25s ease !important;
                    outline: none !important;
                }
                .cdzv-dropdown-btn:hover {
                    background: rgba(255, 255, 255, 0.08) !important;
                    border-color: rgba(253, 109, 249, 0.4) !important;
                    box-shadow: 0 4px 15px rgba(109, 50, 236, 0.2) !important;
                }
                .cdzv-dropdown-chevron {
                    transition: transform 0.25s ease !important;
                }
                .cdzv-dropdown-chevron.open {
                    transform: rotate(180deg) !important;
                }
                .cdzv-dropdown-menu {
                    position: absolute !important;
                    top: calc(100% + 8px) !important;
                    right: 0 !important;
                    width: 220px !important;
                    background: rgba(12, 6, 20, 0.96) !important;
                    backdrop-filter: blur(25px) !important;
                    -webkit-backdrop-filter: blur(25px) !important;
                    border: 1px solid rgba(255, 255, 255, 0.1) !important;
                    border-radius: 12px !important;
                    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5), 0 0 20px rgba(123, 47, 206, 0.15) !important;
                    padding: 6px !important;
                    opacity: 0 !important;
                    visibility: hidden !important;
                    transform: translateY(-10px) scale(0.95) !important;
                    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
                    z-index: 300000 !important;
                }
                .cdzv-dropdown-menu.open {
                    opacity: 1 !important;
                    visibility: visible !important;
                    transform: translateY(0) scale(1) !important;
                }
                .cdzv-dropdown-item {
                    display: flex !important;
                    align-items: center !important;
                    gap: 10px !important;
                    color: rgba(255, 255, 255, 0.8) !important;
                    text-decoration: none !important;
                    padding: 10px 14px !important;
                    font-size: 14px !important;
                    font-weight: 500 !important;
                    border-radius: 8px !important;
                    transition: all 0.2s ease !important;
                }
                .cdzv-dropdown-item:hover {
                    color: #ffffff !important;
                    background: rgba(255, 255, 255, 0.08) !important;
                    padding-left: 18px !important;
                }

                /* Premium Login Button */
                .cdzv-login-btn {
                    background: linear-gradient(135deg, #7b2fce 0%, #5a1da8 100%) !important;
                    color: #ffffff !important;
                    text-decoration: none !important;
                    font-size: 14px !important;
                    font-weight: 700 !important;
                    padding: 10px 24px !important;
                    border-radius: 10px !important;
                    border: none !important;
                    box-shadow: 0 4px 15px rgba(123, 47, 206, 0.3) !important;
                    transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
                    display: inline-flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    cursor: pointer !important;
                }
                .cdzv-login-btn:hover {
                    transform: translateY(-2px) !important;
                    background: linear-gradient(135deg, #8b3fde 0%, #6a2db8 100%) !important;
                    box-shadow: 0 6px 20px rgba(253, 109, 249, 0.5), 0 0 10px rgba(123, 47, 206, 0.6) !important;
                }

                /* Lang capsule switcher */
                .cdzv-lang-capsule {
                    display: flex !important;
                    border: 1px solid rgba(255, 255, 255, 0.1) !important;
                    border-radius: 10px !important;
                    overflow: hidden !important;
                    background: rgba(255, 255, 255, 0.04) !important;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
                }
                .cdzv-lang-item {
                    font-size: 13px !important;
                    font-weight: 700 !important;
                    padding: 8px 12px !important;
                    color: rgba(255, 255, 255, 0.6) !important;
                    text-decoration: none !important;
                    transition: all 0.25s ease !important;
                }
                .cdzv-lang-item:hover {
                    color: #ffffff !important;
                    background: rgba(255, 255, 255, 0.06) !important;
                }
                .cdzv-lang-item.active {
                    color: #ffffff !important;
                    background: linear-gradient(135deg, #7b2fce 0%, #5a1da8 100%) !important;
                    box-shadow: 0 0 10px rgba(123, 47, 206, 0.5) !important;
                }

                /* Hamburger animations */
                .cdzv-hamburger-btn {
                    background: transparent !important;
                    border: none !important;
                    cursor: pointer !important;
                    padding: 10px !important;
                    display: none !important;
                    flex-direction: column !important;
                    gap: 5px !important;
                    z-index: 350000 !important;
                    outline: none !important;
                }
                .cdzv-hamburger-line {
                    width: 24px !important;
                    height: 2px !important;
                    background-color: #ffffff !important;
                    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1) !important;
                }
                .cdzv-hamburger-btn.open .line-1 {
                    transform: translateY(7px) rotate(45deg) !important;
                }
                .cdzv-hamburger-btn.open .line-2 {
                    opacity: 0 !important;
                }
                .cdzv-hamburger-btn.open .line-3 {
                    transform: translateY(-7px) rotate(-45deg) !important;
                }

                /* Mobile Drawer Styles */
                .cdzv-mobile-overlay {
                    position: fixed !important;
                    top: 0 !important;
                    left: 0 !important;
                    right: 0 !important;
                    bottom: 0 !important;
                    background: rgba(6, 3, 10, 0.6) !important;
                    backdrop-filter: blur(8px) !important;
                    -webkit-backdrop-filter: blur(8px) !important;
                    z-index: 299999 !important;
                    opacity: 0 !important;
                    visibility: hidden !important;
                    transition: all 0.3s ease !important;
                }
                .cdzv-mobile-overlay.open {
                    opacity: 1 !important;
                    visibility: visible !important;
                }

                .cdzv-mobile-drawer {
                    position: fixed !important;
                    top: 0 !important;
                    right: 0 !important;
                    bottom: 0 !important;
                    width: 100% !important;
                    max-width: 320px !important;
                    height: 100vh !important;
                    background: rgba(12, 6, 20, 0.98) !important;
                    backdrop-filter: blur(25px) !important;
                    -webkit-backdrop-filter: blur(25px) !important;
                    border-left: 1px solid rgba(255, 255, 255, 0.08) !important;
                    box-shadow: -10px 0 40px rgba(0, 0, 0, 0.5) !important;
                    padding: 100px 24px 40px 24px !important;
                    box-sizing: border-box !important;
                    display: flex !important;
                    flex-direction: column !important;
                    gap: 24px !important;
                    z-index: 300000 !important;
                    transform: translateX(100%) !important;
                    transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1) !important;
                }
                .cdzv-mobile-drawer.open {
                    transform: translateX(0) !important;
                }

                /* Mobile Drawer Links */
                .cdzv-mobile-link {
                    color: #ffffff !important;
                    text-decoration: none !important;
                    font-size: 18px !important;
                    font-weight: 600 !important;
                    padding: 12px 16px !important;
                    border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
                    transition: all 0.2s ease !important;
                    text-align: center !important;
                }
                .cdzv-mobile-link:hover {
                    color: #FD6DF9 !important;
                    background: rgba(255, 255, 255, 0.04) !important;
                }

                .cdzv-desktop-nav-wrapper {
                    display: flex !important;
                    align-items: center !important;
                    gap: 20px !important;
                }

                @media (max-width: 991px) {
                    .cdzv-desktop-nav-wrapper {
                        display: none !important;
                    }
                    .cdzv-hamburger-btn {
                        display: flex !important;
                    }
                }
            `}} />
            
            <div className="cdzv-header-container">
                {/* Logo */}
                <a href="/index_ua#home" style={{ display: "flex", alignItems: "center" }}>
                    <img src={Logo} alt="CDZV Logo" style={{
                        height: "44px",
                        borderRadius: "8px",
                        boxShadow: "0 0 15px rgba(123, 47, 206, 0.3)",
                        transition: "transform 0.3s ease"
                    }} 
                    onMouseOver={(e) => e.target.style.transform = "scale(1.03)"}
                    onMouseOut={(e) => e.target.style.transform = "scale(1)"}
                    />
                </a>

                {/* Desktop Nav */}
                <nav className="cdzv-desktop-nav-wrapper">
                    <a href="/index_ua#home" className="cdzv-nav-link">Початок</a>
                    <a href="/index_ua#faq" className="cdzv-nav-link">F.A.Q.</a>
                    
                    {/* Documentation dropdown */}
                    <div className="cdzv-dropdown-container" ref={dropdownRef}>
                        <button className="cdzv-dropdown-btn" onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                                <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                                <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                            </svg>
                            Документація
                            <svg className={`cdzv-dropdown-chevron ${isDropdownOpen ? "open" : ""}`} width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </button>
                        <div className={`cdzv-dropdown-menu ${isDropdownOpen ? "open" : ""}`}>
                            <a href="https://docs.cdzv.com/code-zero-visual-trading_ua" target="_blank" rel="noopener noreferrer" className="cdzv-dropdown-item">Українська</a>
                            <a href="https://docs.cdzv.com/code-zero-visual-trading_en" target="_blank" rel="noopener noreferrer" className="cdzv-dropdown-item">English</a>
                            <a href="https://docs.cdzv.com/code-zero-visual-trading_ru" target="_blank" rel="noopener noreferrer" className="cdzv-dropdown-item">Русская</a>
                        </div>
                    </div>

                    <a href="https://panel.cdzv.com" target="_blank" rel="noopener noreferrer" className="cdzv-login-btn">
                        Увійти до панелі
                    </a>

                    {/* Language Capsule Selector */}
                    <div className="cdzv-lang-capsule">
                        <a href="https://cdzv.com" className="cdzv-lang-item">EN</a>
                        <a href="https://cdzv.com/index_ua" className="cdzv-lang-item active">UA</a>
                        <a href="https://cdzv.com/index_ru" className="cdzv-lang-item">RU</a>
                    </div>
                </nav>

                {/* Hamburger for Mobile */}
                <button className={`cdzv-hamburger-btn ${isOpen ? "open" : ""}`} onClick={() => setIsOpen(!isOpen)} aria-label="Мобільне меню">
                    <span className="cdzv-hamburger-line line-1"></span>
                    <span className="cdzv-hamburger-line line-2"></span>
                    <span className="cdzv-hamburger-line line-3"></span>
                </button>
            </div>

            {/* Mobile Drawer Overlay */}
            <div className={`cdzv-mobile-overlay ${isOpen ? "open" : ""}`} onClick={() => setIsOpen(false)}></div>

            {/* Mobile Drawer */}
            <div className={`cdzv-mobile-drawer ${isOpen ? "open" : ""}`}>
                <a href="/index_ua#home" className="cdzv-mobile-link" onClick={() => setIsOpen(false)}>Початок</a>
                <a href="/index_ua#faq" className="cdzv-mobile-link" onClick={() => setIsOpen(false)}>F.A.Q.</a>
                
                {/* Mobile accordion for Doc Selector */}
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <div style={{
                        fontSize: "12px",
                        fontWeight: "700",
                        textTransform: "uppercase",
                        letterSpacing: "1px",
                        color: "rgba(255, 255, 255, 0.4)",
                        textAlign: "center",
                        marginTop: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "6px"
                    }}>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                        </svg>
                        Документація
                    </div>
                    <a href="https://docs.cdzv.com/code-zero-visual-trading_ua" target="_blank" rel="noopener noreferrer" className="cdzv-mobile-link" onClick={() => setIsOpen(false)} style={{ fontSize: "15px", padding: "8px" }}>Українська</a>
                    <a href="https://docs.cdzv.com/code-zero-visual-trading_en" target="_blank" rel="noopener noreferrer" className="cdzv-mobile-link" onClick={() => setIsOpen(false)} style={{ fontSize: "15px", padding: "8px" }}>English</a>
                    <a href="https://docs.cdzv.com/code-zero-visual-trading_ru" target="_blank" rel="noopener noreferrer" className="cdzv-mobile-link" onClick={() => setIsOpen(false)} style={{ fontSize: "15px", padding: "8px" }}>Русская</a>
                </div>

                <a href="https://panel.cdzv.com" target="_blank" rel="noopener noreferrer" className="cdzv-login-btn" onClick={() => setIsOpen(false)} style={{ width: "100%", marginTop: "16px" }}>
                    Увійти до панелі
                </a>

                {/* Mobile Language Switcher */}
                <div className="cdzv-lang-capsule" style={{ width: "100%", marginTop: "auto", justifyContent: "center" }}>
                    <a href="https://cdzv.com" className="cdzv-lang-item" style={{ flex: 1, textAlign: "center" }}>EN</a>
                    <a href="https://cdzv.com/index_ua" className="cdzv-lang-item active" style={{ flex: 1, textAlign: "center" }}>UA</a>
                    <a href="https://cdzv.com/index_ru" className="cdzv-lang-item" style={{ flex: 1, textAlign: "center" }}>RU</a>
                </div>
            </div>
        </header>
    );
};

Object.assign(CdzvMenu_ua, {
    defaultProps,
    overrides
});

export default CdzvMenu_ua;
